const UPDATE_ITEMS = [
  {
    date: '2026.07.30',
    title: '多部暑期档大片高清片源全面上线',
    desc: '包括年度动作巨制和口碑文艺片在内的十余部暑期档热门影片已同步上线天美影视，高清画质流畅观看。',
  },
  {
    date: '2026.07.28',
    title: '播放引擎全面升级，加载速度提升40%',
    desc: '天美影视完成核心播放引擎升级，视频首帧加载时间缩短40%，拖动进度条响应更灵敏，观影体验大幅提升。',
  },
  {
    date: '2026.07.25',
    title: '新增超清画质选项，支持4K分辨率',
    desc: '部分热门影片现已支持超清画质播放，在高速网络环境下可享受接近4K的清晰观影体验。',
  },
  {
    date: '2026.07.20',
    title: '古装权谋大剧《长安风云录》第二季首播',
    desc: '备受期待的《长安风云录》第二季正式上线，天美影视全网高清同步播出，首日播放量即突破千万。',
  },
  {
    date: '2026.07.15',
    title: '移动端适配优化完成，手机观影更便捷',
    desc: '针对移动端进行了全面适配优化，页面布局自适应各类屏幕尺寸，触控操作更加流畅自然。',
  },
  {
    date: '2026.07.10',
    title: '悬疑剧场专题上线，百部佳作一站式畅看',
    desc: '全新悬疑剧场专题页面正式上线，精选国内外百部高分悬疑作品，烧脑爱好者不可错过的追剧盛宴。',
  },
  {
    date: '2026.07.05',
    title: '天美影视日活跃用户突破五百万',
    desc: '凭借流畅稳定的播放体验和丰富的内容储备，天美影视日活跃用户数再创新高，感谢每一位观众的支持。',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">最新动态</h2>
          <p className="mt-2 text-sm text-foreground-600">天美影视平台更新与内容上线资讯</p>
        </div>

        <div className="max-w-[800px] mx-auto">
          {UPDATE_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="relative pl-8 pb-8 last:pb-0 group"
            >
              <div className="absolute left-0 top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 z-10"></div>
              {idx < UPDATE_ITEMS.length - 1 && (
                <div className="absolute left-[5px] top-4 bottom-0 w-0.5 bg-background-300"></div>
              )}
              <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200/40 transition-all duration-300 cursor-pointer">
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0 sm:justify-between mb-2">
                  <h3 className="font-heading text-sm md:text-base text-foreground-900">{item.title}</h3>
                  <span className="text-xs text-foreground-500 bg-background-100 px-2.5 py-1 rounded-full whitespace-nowrap w-fit">{item.date}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}